<script setup>
// Top-of-dashboard warning for telephony agents on a non-Russian IP (VPN on).
// UIS/MANGO only route calls from Russian IPs, so with a VPN the softphone
// registers fine (200 OK) but calls never ring — a silent failure. We surface it
// proactively instead of letting agents miss calls.
//
// Detection is server-side (agent's request IP → country) via a lightweight
// endpoint kept OFF the SIP-registration path. We only warn when confident the
// IP is foreign; an unknown country stays silent to avoid false alarms. Re-checks
// on an interval so the banner clears once the agent turns the VPN off.
import { ref, onMounted, onBeforeUnmount } from 'vue';
import Banner from 'dashboard/components-next/banner/Banner.vue';
import TelephonyAPI from 'dashboard/api/telephony';

const show = ref(false);
let timer = null;

const check = async () => {
  try {
    const { data } = await TelephonyAPI.networkCheck();
    if (!data?.telephony_active) {
      // No voice line for this agent — nothing to warn about, stop polling.
      show.value = false;
      clearInterval(timer);
      return;
    }
    const country = (data.country_code || '').toUpperCase();
    show.value = country !== '' && country !== 'RU';
  } catch (error) {
    show.value = false;
  }
};

onMounted(() => {
  check();
  timer = setInterval(check, 60000);
});
onBeforeUnmount(() => clearInterval(timer));
</script>

<template>
  <Banner
    v-if="show"
    color="ruby"
    class="!rounded-none !justify-center [&_p]:m-0"
  >
    <span class="text-xs font-medium">
      ⚠️ Похоже, включён VPN (IP не российский) — звонки работать не будут.
      Телефония работает только с российского IP: отключите VPN.
    </span>
  </Banner>
</template>
